import classNames from "classnames";

import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

export interface FormLabelProps {
  className?: string;
  description?: string;
  fieldId: string;
  hideBorder?: boolean;
  inline?: boolean;
  label: string;
  labelClassName?: string;
}

export const FormLabel = ({
  className = "",
  fieldId,
  label,
  labelClassName,
  description,
  hideBorder = false,
  inline = false,
}: FormLabelProps) => (
  <div
    className={classNames(
      anchorClassNames("form-group", {
        "no-border": hideBorder,
      }),
      inline && legacyClassNames("form-group--inline"),
      className,
    )}
  >
    <label
      className={classNames(
        anchorClassNames("form-group__label"),
        "text-dark font-semibold",
        labelClassName,
      )}
      htmlFor={fieldId}
    >
      {label}
    </label>
    {description && (
      <div className={anchorClassNames("field-description")}>{description}</div>
    )}
  </div>
);

FormLabel.displayName = "Form.Label";
